"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const icons_1 = require("../../assets/icons");
const Hamburger_1 = __importDefault(require("../../assets/icons/Hamburger"));
const components_1 = require("../../components");
const ModalMenu_1 = __importDefault(require("../../components/modal/ModalMenu"));
const CustomText_1 = __importDefault(require("../../components/text/CustomText"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const scale_1 = require("../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const NotFoundScreen = () => {
    const [menuVisible, setMenuVisible] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(Hamburger_1.default, null), onLeftPress: () => {
                setMenuVisible(true);
            } }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.body },
            react_1.default.createElement(react_native_1.View, { style: { alignSelf: 'center', marginTop: (0, scale_1.verticalScale)(169) } },
                react_1.default.createElement(icons_1.IC_ERROR, null)),
            react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles_1.default.title }, "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u306F\u5B58\u5728\u3057\u307E\u305B\u3093"),
            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.description }, "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u306F\u5B58\u5728\u3057\u306A\u3044\u304B\u3001\u65E2\u306B\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002URL\u306B\u9593\u9055\u3044\u306A\u3044\u304B\u518D\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"),
            react_1.default.createElement(components_1.LinkButton, { title: '\u30DB\u30FC\u30E0\u753B\u9762\u306B\u623B\u308B', onPress: () => { (0, rootNavigation_1.reset)({ index: 0, routeName: Routes_1.default.MAINTABBAR }); }, style: styles_1.default.button })),
        react_1.default.createElement(ModalMenu_1.default, { visible: menuVisible, onClose: () => setMenuVisible(false) })));
};
exports.default = NotFoundScreen;
